module.exports = __webpack_public_path__ + "img/reset-password.9597cd15.svg";